import api from 'src/api';

export const loginUser = (data) => {
  return api('/user/login', data, 'post');
};

export const addAppointment = (data) => {
  return api('/tokenappointment', data, 'post');
}

// export const getAppointment = () => {
//   return api('/tokenappointments', null, 'get');
// }
export const getAppointment = ({ token = null, params = {} }) => {
  return api('/tokenappointments', null, 'get', false, null, 'json', params);
};

export const getAppointmentById = (appointmentId) => {
  return api(`/tokenappointment/${appointmentId}`, null, 'get');
}

export const getAppointmentByPatientId = ({ patientId, params = {} }) => {
  return api(`/tokenappointment/patient/${patientId}`, null, 'get', false, null, 'json', params);
};

export const getClinics = () => {
  return api('/clinic', null, 'get')
}
export const updateClinicById = (clinicId, data) => {
  return api(`/clinic/${clinicId}`, data, 'put')
}

export const getClinicById = (clinicId) => {
  return api(`/clinic/${clinicId}`, null, 'get')
}

export const getAllDoctors = () => {
  return api('/admin/profiles', null, 'get')
}

export const adddPatient = (data) => {
  return api('/patient', data, 'post')
}

// export const getPatient = () => {
//   return api('/patients', null, 'get')
// }

export const getPatient = ({ token = null, params = {} }) => {
  return api('/patients', null, 'get', false, null, 'json', params);
};

export const getPatientById = (patientId) => {
  return api(`/patient/${patientId}`, null, 'get')
}

export const getPatientInfoById = (patientId) => {
  return api(`/patientinfo/patient/${patientId}`, null, 'get')
}

export const getTagByPatientId = (patientId) => {
  return api(`/tag/patient/${patientId}`, null, 'get')
}

export const getTags = () => {
  return api(`/tags`, null, 'get')
}

export const updateStatus = (appointmentId, data) => {
  return api(`/recordstatus/${appointmentId}`, data, 'put')
}

export const postMedicalRecord = (data) => {
  return api(`/medicalrecord`, data, 'post')
}

export const getMedicalRecordByPatientId = ({ patientId, params = {} }) => {
  return api(`/medicalrecord/patient/${patientId}`, null, 'get', false, null, 'json', params);
}

export const getMedicalRecordById = (medicalId) => {
  return api(`/medicalrecord/${medicalId}`, null, 'get');
}
export const deleteMedicalRecordById = (id) => {
  return api(`/medicalrecord/${id}`, null, 'delete')
}
export const fetchAvailability = (clinicId) => {
  return api(`/getavailability/${clinicId}`, null, 'get');
};

export const getTemplateByClinicId = (clinicId) => {
  return api(`template/clinic/${clinicId}`, null, 'get', false, null, 'json', { _t: Date.now() });
}

export const getFollowupByPatientId = ({ patientId, params = {} }) => {
  return api(`/followup/patient/${patientId}`, null, 'get', false, null, 'json', params);
}

export const getTreatmentByPatientId = ({ patientId, params = {} }) => {
  return api(`/treatment/patient/${patientId}`, null, 'get', false, null, 'json', params);
}
export const getTreatmentById = (treatmentId) => {
  return api(`/treatment/${treatmentId}`, null, 'get');
}

export const getCustomFieldsByClinicId = (clinicId) => {
  return api(`/clinic/custom-fields/${clinicId}`, null, 'get');
}

export const postCustomPatientFields = (data) => {
  return api(`/clinic/custom-fields`, data, 'post');
}
export const getBillingsByPatientId = ({ patientId, params = {} }) => {
  return api(`/billing/patient/${patientId}`, null, 'get', false, null, 'json', params);
}

export const postMessage = (data) => {
  return api(`/message`, data, 'post');
}
export const getMessagesByPatientId = ({ patientId, params = {} }) => {
  return api(`/message/patient/${patientId}`, null, 'get', false, null, 'json', params);
}
export const deleteMessageById = (id) => {
  return api(`/message/${id}`, null, 'delete');
}
export const getReportsByPatientId = ({ patientId, params = {} }) => {
  return api(`/file/patient/${patientId}`, null, 'get', false, null, 'json', params);
}
export const postTemplate = (data) => {
  return api(`/template`, data, 'post')
}
export const getReportViewById = (reportId) => {
  return api(`/view/${reportId}`, null, 'get', false, null, 'blob');
}
export const getReportDownloadById = (downloadId) => {
  return api(`/download/${downloadId}`, null, 'get', false, null, 'blob');
}

export const postDoctorProfile = (data) => {
  return api(`/profile`, data, 'post');
}
export const getDoctorProfileById = (doctId) => {
  return api(`profile/${doctId}`, null, 'get');
}
export const getClinicProfileById = (clinicId) => {
  return api(`clinicprofile/${clinicId}`, null, 'get', false, null, 'json', { _t: Date.now() });
}

export const getAreaByPatientId = (patientId) => {
  return api(`/area/patient/${patientId}`, null, 'get')
}
export const getAreas = () => {
  return api(`/areas`, null, 'get')
}
export const updatePatientById = (patientId, data) => {
  return api(`/patient/${patientId}`, data, 'put')
}
export const updatePatientInfoById = (infoId, data) => {
  return api(`/patientinfo/${infoId}`, data, 'put')
}
export const updateAreaById = (areaId, data) => {
  return api(`/area/${areaId}`, data, 'put')
}
export const updateTagById = (tagId, data) => {
  return api(`/tag/${tagId}`, data, 'put')
}
export const postTag = (data) => {
  return api(`/tag`, data, 'post')
}
export const postArea = (data) => {
  return api(`/area`, data, 'post')
}
export const postPatientInfo = (data) => {
  return api(`/patientinfo`, data, 'post')
}
export const postTreatment = (data) => {
  return api(`/treatment`, data, 'post')
}
export const postBilling = (data) => {
  return api(`/billing`, data, 'post')
}
export const postUpload = (data) => {
  return api(`/upload`, data, 'post', true)
}
export const postUploadLogo = (data) => {
  return api(`/clinic/upload-logo`, data, 'post', true)
}
export const postProfilePic = (data) => {
  return api(`/doctor/upload-profile`, data, 'post', true)
}
export const postFollowup = (data) => {
  return api(`/followup`, data, 'post', true)
}
export const postStaff = (data) => {
  return api(`/staff`, data, 'post')
}
// export const getStaff = () => {
//   return api(`/staff`, null, 'get')
// }
export const getStaff = ({ token = null, params = {} }) => {
  return api('/staff', null, 'get', false, null, 'json', params);
};

export const postClinic = (data) => {
  return api(`/clinic`, data, 'post')
}

export const getPatientHistory = (patientId) => {
  return api(`/patient/history/${patientId}`)
}

export const postTask = (data) => {
  return api(`/task`, data, 'post')
}

export const getTask = ({ token = null, params = {} }) => {
  return api('/tasks', null, 'get', false, null, 'json', params);
};

export const postComment = (taskId, data) => {
  return api(`/task/comments/${taskId}`, data, 'post')
}

export const clinicProfile = (clinicId) => {
  return api(`/clinicprofile/${clinicId}`, null, 'get', false, null, 'json', { _t: Date.now() });
}

export const getBilling = ({ token = null, params = {} }) => {
  return api('/billings', null, 'get', false, null, 'json', params);
};

export const getSummary = () => {
  return api('/summary', null, 'get', false);
};

export const getGoogleAuthUrl = (token) => {
  return api('/api/google/url', token, 'get', false);
};
export const postClinicProfile = (data) => {
  return api(`/clinicprofile`, data, 'post')
}

export const getSummaryStat = () => {
  return api('/dashboard/summary', null, 'get', false);
};

export const getMonthlyAppointments = () => {
  return api('/dashboard/appointments', null, 'get', false);
};

export const getTaskOverview = () => {
  return api('/dashboard/tasks', null, 'get', false);
};

export const getAppointmentStatusSummary = () => {
  return api('/dashboard/appointmentstatus', null, 'get', false);
};

export const getTransactions = () => {
  return api('/dashboard/transactions', null, 'get', false);
};

export const getPendingTransactions = () => {
  return api('/dashboard/pendingtransactions', null, 'get', false);
};

export const getAvgEarningAndFollowUpRate = () => {
  return api('/dashboard/getAvgEarningAndFollowUpRate', null, 'get', false);
};

export const getAvailability = (clinicId) => {
  return api(`/getavailability/${clinicId}`, null, 'get')
};

export const updateAvailability = (data) => {
  return api(`/update`, data, 'post');
}

export const getBillingById = (billingId) => {
  return api(`/billing/${billingId}`, null, 'get');
}

export const getAvailableSlots = ({ token = null, params = {} }) => {
  return api('/available-timeslots', token, 'get', false, null, 'json', params);
};

export const patientLookup = (phone) => {
  return api(`/api/patients/lookup?phone=${phone}`, null, 'get');
};

// Notifications
export const postNotification = (data) => {
  return api(`/notification`, data, 'post');
}

export const getNotifications = ({ params = {} } = {}) => {
  return api('/notifications', null, 'get', false, null, 'json', params);
}

export const updateNotification = (notificationId, data) => {
  return api(`/notification/${notificationId}`, data, 'put');
}

export const getNotificationById = (notificationId) => {
  return api(`/notification/${notificationId}`, null, 'get');
}

export const deleteNotification = (notificationId) => {
  return api(`/notification/${notificationId}`, null, 'delete');
}

export const getUsers = ({ params = {} } = {}) => {
  return api('/users', null, 'get', false, null, 'json', params);
}// Medical Case System
export const getActiveCase = (params = {}) => {
  return api(`/medicalcase/active`, null, 'get', false, null, 'json', params);
};

export const getCasesByPatientId = ({ patientId, params = {} }) => {
  return api(`/medicalcase/patient/${patientId}`, null, 'get', false, null, 'json', params);
};

export const getSpecialities = () => {
  return api(`/speciality`, null, 'get', false, null, 'json');
};
